import apiClient from './apiClient';
import { API_ENDPOINTS } from '../config/apiConfig';
import {
  RtuPingTemplateAssignmentDto,
  RtuPingTemplateAssignmentRequestDto,
  RtuPingTemplateDto,
  RtuPingTemplateUpsertDto,
  RtuRegistrationBackfillResponseDto,
} from '../types/RtuPingSettings';

export const listRtuPingTemplates = async (): Promise<RtuPingTemplateDto[]> => {
  const response = await apiClient.get<RtuPingTemplateDto[]>(API_ENDPOINTS.SETTINGS.RTU_PING_TEMPLATES);
  return response.data;
};

export const createRtuPingTemplate = async (request: RtuPingTemplateUpsertDto): Promise<RtuPingTemplateDto> => {
  const response = await apiClient.post<RtuPingTemplateDto>(API_ENDPOINTS.SETTINGS.RTU_PING_TEMPLATES, request);
  return response.data;
};

export const updateRtuPingTemplate = async (templateId: number, request: RtuPingTemplateUpsertDto): Promise<RtuPingTemplateDto> => {
  const response = await apiClient.put<RtuPingTemplateDto>(`${API_ENDPOINTS.SETTINGS.RTU_PING_TEMPLATES}/${templateId}`, request);
  return response.data;
};

export const listRtuPingAssignments = async (rtuIds?: Array<number | string>): Promise<RtuPingTemplateAssignmentDto[]> => {
  const params = rtuIds && rtuIds.length > 0 ? { rtuIds: rtuIds.join(',') } : undefined;
  const response = await apiClient.get<RtuPingTemplateAssignmentDto[]>(API_ENDPOINTS.SETTINGS.RTU_PING_ASSIGNMENTS, { params });
  return response.data;
};

export const assignRtuPingTemplate = async (request: RtuPingTemplateAssignmentRequestDto): Promise<RtuPingTemplateAssignmentDto> => {
  const response = await apiClient.post<RtuPingTemplateAssignmentDto>(API_ENDPOINTS.SETTINGS.RTU_PING_ASSIGNMENTS, request);
  return response.data;
};

export const assignRtuPingTemplateBulk = async (templateId: number, rtuIds: number[]): Promise<RtuPingTemplateAssignmentDto[]> => {
  const response = await apiClient.post<RtuPingTemplateAssignmentDto[]>(
    `${API_ENDPOINTS.SETTINGS.RTU_PING_TEMPLATES}/${templateId}/assignments`,
    { rtuIds }
  );
  return response.data;
};

export const unassignRtuPingTemplates = async (rtuIds: number[]): Promise<RtuPingTemplateAssignmentDto[]> => {
  const response = await apiClient.post<RtuPingTemplateAssignmentDto[]>(
    `${API_ENDPOINTS.SETTINGS.RTU_PING_ASSIGNMENTS}/unassign`,
    { rtuIds }
  );
  return response.data;
};

export const backfillRtuRegistrationTimes = async (request: {
  directory?: string | null;
  dryRun?: boolean;
}): Promise<RtuRegistrationBackfillResponseDto> => {
  const response = await apiClient.post<RtuRegistrationBackfillResponseDto>(API_ENDPOINTS.SETTINGS.RTU_REGISTRATION_BACKFILL, request);
  return response.data;
};
